"use client"

import { ComponentConfig } from "@measured/puck"
import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api"
import { Spin } from "antd"
import { useRef, useState } from "react"
import { twMerge } from "tailwind-merge"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../../lib/helper"

export interface BaseSystemProps extends CommonStylesProps {
  title?: string
  subTitle?: string
}

interface BaseSystem {
  id: string
  attributes: {
    name: string
    email: string
    workingTime: string
    address: string
    hotline: string
    latitude: string
    longitude: string
    linkMap: string
    rating: string
    numberOfReviews: string
  }
}

const position: BaseSystem = {
  id: "1",
  attributes: {
    name: "Bugis Cube",
    email: "",
    workingTime: "",
    address: "470 N Bridge Rd, Singapore 188735",
    hotline: "",
    latitude: "1.300486",
    longitude: "103.856559",
    linkMap: "https://maps.google.com/?q=1.300486,103.856559",
    rating: "3,9",
    numberOfReviews: "1.075",
  },
}

export const RenderConfig: ComponentConfig<BaseSystemProps> = {
  render: ({ styles, responsiveType, className, title, subTitle }) => {
    const id = `form-register-${Math.random().toString(36).substr(2, 9)}`

    const containerStyle = {
      width: "100%",
      height: "100%",
    }

    const { isLoaded } = useJsApiLoader({
      id: "google-map-script",
      googleMapsApiKey: "AIzaSyDGodfPRJzvat54G3EAHM87ymkPGL2HsvE",
    })

    const mergedStyles = {
      mobile: { ...styles?.mobile },
      tablet: { ...styles?.tablet },
      desktop: { ...styles?.desktop },
    }

    const responsiveCSS = generateResponsiveCSS(id, mergedStyles || {}, responsiveType)
    const mapRef = useRef<HTMLDivElement>(null)
    const [mapTypeId, setMapTypeId] = useState<"roadmap" | "satellite">("roadmap")

    return (
      <>
        {responsiveCSS}
        <div className={`${id} ${twMerge(className)} w-full text-center rounded-xl`}>
          <div className="flex sm:flex-row flex-col-reverse sm:gap-3 gap-0 ">
            <div className="w-full h-full relative flex items-center justify-center">
              <div
                className="relative w-[460px] h-[460px] overflow-scroll max-sm:w-[280px] max-sm:h-[214px] scrollable-map"
                ref={mapRef}
              >
                {isLoaded && position ? (
                  <>
                    <div className="w-[130%] h-[105%] max-sm:w-[230%] max-sm:h-[200%]">
                      <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={{
                          lat: parseFloat(position.attributes.latitude),
                          lng: parseFloat(position.attributes.longitude),
                        }}
                        zoom={16}
                        options={{ disableDefaultUI: true, mapTypeId: mapTypeId }}
                      >
                        <MarkerF
                          position={{
                            lat: parseFloat(position.attributes.latitude),
                            lng: parseFloat(position.attributes.longitude),
                          }}
                        />
                      </GoogleMap>
                    </div>
                    <div className={` bg-white p-3 z-10 absolute top-2 left-2 flex flex-row w-[300px] justify-between`}>
                      <div className="  text-left">
                        <div className="font-bold  mb-1 text-[14px]">{position.attributes.name}</div>
                        <div className="flex items-start gap-1 text-[12px]">
                          <div className="font-normal text-[#5B5B5B]">{position?.attributes.address}</div>
                        </div>
                        <div className="flex items-center gap-1 mt-1 text-[12px]">
                          <span className="text-sm text-[#5B5B5B] font-medium">{position.attributes.rating}</span>
                          <span className="text-sm text-[#f56642]">★★★★☆</span>
                          <span className="text-[12px] text-[#1A73E8] text ml-1 max-sm:hidden">
                            {position.attributes.numberOfReviews} bài viết
                          </span>
                        </div>
                        <a
                          href={position?.attributes.linkMap}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-[#1A73E8] text-[12px] mt-1 block"
                        >
                          Xem bản đồ lớn hơn
                        </a>
                      </div>
                      <div className="flex flex-col justify-start items-center group cursor-pointer">
                        <img
                          src="../../../../../../../public/images/direct.png"
                          className="w-[22px] h-[22px] group-hover:hidden"
                        />
                        <img
                          src="../../../../../../../public/images/direct2.png"
                          className="w-[22px] h-[22px] group-hover:block hidden"
                        />
                        <a href="https://www.google.com/maps/dir//Bugis+Cube+470+N+Bridge+Rd+Singapore+188735/@1.2981918,103.8556572,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x31da19a54dc6947b:0xe97ad2a6497ffe2b!2m2!1d103.8556572!2d1.2981918?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D">
                          <p className="group-hover:underline text-[12px]">Chỉ đường</p>
                        </a>
                      </div>
                    </div>
                    <button
                      onClick={() => setMapTypeId(prev => (prev === "roadmap" ? "satellite" : "roadmap"))}
                      className="z-10 absolute top-[410px] left-2 p-[2px] bg-white rounded-sm"
                    >
                      <div className="z-10  w-[38px] h-[38px] relative">
                        <GoogleMap
                          mapContainerStyle={{ width: "100%", height: "100%" }}
                          options={{ disableDefaultUI: true, mapTypeId: "satellite" }}
                          zoom={1}
                        >
                          <MarkerF
                            position={{
                              lat: parseFloat(position.attributes.latitude),
                              lng: parseFloat(position.attributes.longitude),
                            }}
                          />
                        </GoogleMap>
                      </div>
                    </button>
                    <div className="flex flex-col absolute top-[350px] -right-[7.5rem]">
                      <button
                        className="bg-white text-black w-[40px] h-[40px] flex justify-center items-center group border-1 border-b"
                        style={{ borderColor: "rgb(230, 230, 230)" }}
                      >
                        <svg
                          className="group-hover:hidden"
                          width={18}
                          height={18}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 18 18"
                        >
                          <path fill="#666" d="M18 7h-7V0H7v7H0v4h7v7h4v-7h7z" />
                        </svg>
                        <svg
                          className="group-hover:block hidden"
                          width={18}
                          height={18}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 18 18"
                        >
                          <path fill="#000" d="M18 7h-7V0H7v7H0v4h7v7h4v-7h7z" />
                        </svg>
                      </button>
                      <button className="bg-white text-black w-[40px] h-[40px] flex justify-center items-center group">
                        <svg
                          className="group-hover:hidden"
                          width={18}
                          height={18}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 18 18"
                        >
                          <path fill="#666" d="M0 7h18v4H0V7z" />
                        </svg>
                        <svg
                          className="group-hover:block hidden"
                          width={18}
                          height={18}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 18 18"
                        >
                          <path fill="#000" d="M0 7h18v4H0V7z" />
                        </svg>
                      </button>
                    </div>
                  </>
                ) : (
                  <div className="flex items-center justify-center min-h-[500px]">
                    <Spin size="large" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    )
  },
}
